
/**
 * 메시지 역할
 */
export type ConversationDetailAllOfThreeMessagesItemRole = typeof ConversationDetailAllOfThreeMessagesItemRole[keyof typeof ConversationDetailAllOfThreeMessagesItemRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationDetailAllOfThreeMessagesItemRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
